import { IModuleConfig, MenuKind } from '@simac/ui';
import { CustomWebshopRoute } from '@webshop/custom-webshop/custom-webshop.routes';
import { WebshopRoute } from '../../webshop/webshop.routes';

export const WebshopModuleConfig: IModuleConfig = {
  name: 'webshop',
  injects: [
    {
      name: 'projectmanagement',
      components: [
        {
          name: 'Webshop category management',
          icon: 'far fa-tags',
          translateLabel: 'SSP.WEBSHOP.CATEGORYLABEL',
          permission: 'Module.Webshop.Management.CategoryModify',
          pages: [
            {
              isDefault: true,
              route: 'webshop-category-management',
              loadComponent: () => import('../../projectmanagement/category/pages/category-management.component').then((m) => m.CategoryManagementComponent),
            },
          ],
        },
        {
          name: 'Webshop address management',
          icon: 'far fa-truck',
          translateLabel: 'SSP.WEBSHOP.DELIVERYADDRESS',
          permission: 'Module.Webshop.Management.DeliveryAddressModify',
          pages: [
            {
              isDefault: true,
              route: 'delivery-address-management',
              loadComponent: () => import('../../projectmanagement/delivery/pages/delivery-management.component').then((m) => m.DeliveryManagementComponent),
            },
          ],
        },
        {
          name: 'Webshop product management',
          icon: 'far fa-boxes-stacked',
          translateLabel: 'SSP.WEBSHOP.PRODUCT',
          permission: 'Module.Webshop.Management.ProductModify',
          pages: [
            {
              isDefault: true,
              route: 'product-management',
              loadComponent: () => import('../../projectmanagement/product/pages/product-management.component').then((m) => m.ProductManagementComponent),
            },
          ],
        },
      ],
    },
  ],
  routing: {
    menuKind: MenuKind.Main,
    route: 'webshop',
    children: [
      {
        title: 'MENU.WEBSHOP',
        route: WebshopRoute,
        permission: 'Module.Webshop.Product.View',
        icon: 'far fa-shop',
      },
    ],
  },
  breadCrumb: {
    default: [
      { key: 'page', label: 'MENU.WEBSHOP' },
      { key: 'productlist', label: 'SSP.WEBSHOP.PRODUCTLIST' },
      { key: 'details', label: '' },
    ],
  },
};

export const CustomWebshopModuleConfig: IModuleConfig = {
  name: 'custom-webshop',
  injects: [
    {
      name: 'projectmanagement',
      components: [
        {
          name: 'Webshop custom category management',
          icon: 'far fa-link-horizontal',
          translateLabel: 'SSP.WEBSHOP.CATEGORYLINKLABEL',
          permission: 'Module.Webshop.Management.CustomCategoryModify',
          pages: [
            {
              isDefault: true,
              route: 'webshop-custom-category-management',
              loadComponent: () => import('../../projectmanagement/customcategory/pages/cus-category-management.component').then((m) => m.CusCategoryManagementComponent),
            },
          ],
        },
      ],
    },
  ],
  routing: {
    menuKind: MenuKind.Main,
    route: 'custom-webshop',
    children: [
      {
        title: 'MENU.WEBSHOP',
        route: CustomWebshopRoute,
        permission: 'Module.Webshop.Product.CustomView',
        icon: 'far fa-shop',
      },
    ],
  },
  breadCrumb: {
    default: [
      { key: 'page', label: 'MENU.WEBSHOP' },
      { key: 'details', label: '' },
    ],
  },
};
